import type { SettingsRegistry } from "idfweb-settings";

import type { ViewTab } from "./editors.ts";
import { createSettingsForm } from "./settings-form.ts";
import { settingsModel } from "./settings-model.ts";

/** The settings tab: every declared setting in the settings form. */
export function settingsTab(registry: SettingsRegistry): ViewTab {
    return {
        id: "settings",
        title: "Settings",
        icon: "settings-gear",
        create: () => {
            const form = createSettingsForm(settingsModel(registry), { searchPlaceholder: "Search settings" });
            return { element: form.element, dispose: form.dispose };
        },
    };
}
